import type { Cluster } from './types'

// incidentTitle is an incident's label as the app names it: tampering as what
// the dispatcher has lost, as the alerts rail says it.
export function incidentTitle(c: Cluster): string {
  if (c.label === 'tamper') return 'View lost'
  const words = (c.label || 'Detection').replace(/_/g, ' ')
  return words.charAt(0).toUpperCase() + words.slice(1)
}
